import { createContext } from 'react';

import type { Language } from '../utils/localization.js';

export interface LanguageContextType {
  language: Language;
  setLanguage: (name: Language) => void;
  loading: boolean;
}

const contextDefaultValues: LanguageContextType = {
  language: 'en',
  setLanguage: () => {},
  loading: true,
};

export const LanguageContext = createContext<LanguageContextType>(contextDefaultValues);
